export default __webpack_public_path__ + "static/038-389babd30315d811f467b7a472f81389.png";